import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { excelExport } from '@/util/useXlsx'
import { Download } from '@element-plus/icons-vue'
import { t } from '@/plugins/i18n'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  props: ['data', 'isCrossMall'],
  setup(__props) {

const props = __props
const store = useStore()


const productColumns = computed(() => {
  return [
    {
      title: t('图片'),
      dataIndex: 'productMainImg',
      customRender: (text: any, row: any) => row.productSkuImg || row.productMainImg
    },
    {
      title: t('平台商品信息'),
      dataIndex: 'productPropertiesName',
      customRender: (text: string) => t('商品规格') + ((text || '').split(';') || []).map((e: any) =>
        (e.replace(/[+-]?\d+:[+-]?\d+:/, '') || '').split(':')[1] ?? '').join(';')
    },
    {
      title: t('客户商品sku'),
      dataIndex: 'customerProductMsku'
    },
    {
      title: t('平台商品SKU'),
      dataIndex: 'productSku'
    },
    ...(props.isCrossMall ? [
      {
        title: 'SKUコード',
        dataIndex: 'crossMallProductSku'
      },
      {
        title: '商品名',
        dataIndex: 'crossMallProductTitle'
      }
    ] : []),
    {
      title: t('库存数量'),
      dataIndex: 'useable'
    },
    {
      title: t('发货数量'),
      dataIndex: 'deliveryNums'
    }
  ]
})
const exportData = () => {
  if (props.data?.length) {
    excelExport({
      headers: productColumns.value,
      contents: props.data,
      fileName: t('导出发货数量')
    })
    return
  }
  ElMessage.warning(t('请选择商品'))
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_component_el_button, {
    icon: _unref(Download),
    class: "mr_10",
    onClick: exportData
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('导出发货数量')), 1)
    ]),
    _: 1
  }, 8, ["icon"]))
}
}

})